import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

function DevelopmentDimensionLegend({ data }) {
  const total = data.reduce((sum, entry) => sum + entry.value, 0);

  return (
    <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3 sm:grid-cols-3">
      {data.map((entry) => {
        const percentage = total > 0 ? ((entry.value / total) * 100).toFixed(1) : "0.0";

        return (
          <div key={entry.name} className="flex items-start gap-2 text-xs">
            <span
              className="mt-1 h-2.5 w-2.5 shrink-0 rounded-full"
              style={{ backgroundColor: entry.color }}
            />
            <div className="min-w-0">
              <p className="font-medium leading-tight" title={entry.name}>
                {entry.shortName}
              </p>
              <p className="text-muted-foreground">
                {entry.value} ({percentage}%)
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function DevelopmentDimensionPieCard({ title, data, tooltipContent, emptyMessage }) {
  if (!data || data.length === 0) {
    return (
      <div className="metric-card">
        <h3 className="mb-4 text-sm font-semibold">{title}</h3>
        <div className="flex h-[320px] items-center justify-center">
          <p className="text-sm text-muted-foreground">{emptyMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="metric-card">
      <h3 className="mb-4 text-sm font-semibold">{title}</h3>
      <ResponsiveContainer width="100%" height={260}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="shortName"
            cx="50%"
            cy="50%"
            outerRadius={105}
            innerRadius={58}
            paddingAngle={2}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={tooltipContent} />
        </PieChart>
      </ResponsiveContainer>
      <DevelopmentDimensionLegend data={data} />
      <p className="mt-3 text-center text-xs text-muted-foreground">
        Hover over chart sections to see full dimension names
      </p>
    </div>
  );
}
